<template>
  <UDashboardGroup
    class="auth-layout"
    unit="rem"
    :style="
      bgComputed ? { '--auth-background-image': `url(${bgComputed})` } : {}
    "
    :ui="{
      base: 'flex-col bg-[#FBFAF9]',
    }"
  >
    <UHeader v-if="smAndLarger">
      <template #left>
        <NuxtLink :to="{ name: 'index' }">
          <img
            :src="AppLogo"
            class="size-15"
          />
        </NuxtLink>
      </template>
    </UHeader>

    <UDashboardPanel>
      <template #body>
        <slot />
      </template>
    </UDashboardPanel>
  </UDashboardGroup>
</template>

<script lang="ts" setup>
import BgAuthStoreLogin from "@/assets/images/bg-auth-store-login.png";
import BgAuthStoreLoginMobile from "@/assets/images/bg-auth-store-login-mobile.png";
import BgAuthStaffLogin from "@/assets/images/bg-auth-staff-login.png";
import BgAuthStaffRegister from "@/assets/images/bg-auth-staff-register.png";
import BgAuthResetPassword from "@/assets/images/bg-auth-password.png";
import BgAuthResetPasswordMobile from "@/assets/images/bg-auth-password-mobile.png";
import AppLogo from "@/assets/images/logo.svg";

import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";

const breakpoints = useBreakpoints(breakpointsTailwind);
const smAndLarger = breakpoints.greaterOrEqual("sm"); // sm

const route = useRoute();

const pageType = ref((route.meta.pageType as string) || "default");

const bgComputed = computed(
  () =>
    (smAndLarger.value
      ? {
          loginStaff: BgAuthStaffLogin,
          loginStore: BgAuthStoreLogin,
          registerStaff: BgAuthStaffRegister,
          registerStore: BgAuthStoreLogin,
          resetPassword: BgAuthResetPassword,
          default: undefined,
        }
      : {
          loginStaff: BgAuthStaffLogin,
          loginStore: BgAuthStoreLoginMobile,
          registerStaff: BgAuthStaffRegister,
          registerStore: BgAuthStoreLoginMobile,
          resetPassword: BgAuthResetPasswordMobile,
          default: undefined,
        })[pageType.value],
);

const setPageType = (
  type:
    | "loginStaff"
    | "loginStore"
    | "registerStaff"
    | "registerStore"
    | "resetPassword"
    | "default",
) => {
  pageType.value = type;
};

defineExpose({ setPageType });
</script>

<style scoped>
.auth-layout {
  min-height: 100vh;
  background-image: var(--auth-background-image, none);
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: 100% auto;
}
</style>
